
const fields = vm => ([
  {
    key: 'dateTime',
    sortable: false,
    label: vm.$t('reports.operations-history.visualization.datetime'),
  },
  {
    key: 'operationType',
    sortable: false,
    label: vm.$t('reports.operations-history.visualization.operation'),
  },
  {
    key: 'username',
    sortable: false,
    label: vm.$t('reports.operations-history.visualization.user'),
  },
  {
    key: 'functionality',
    sortable: false,
    label: vm.$t('reports.operations-history.visualization.functionality'),
  },
  {
    key: 'complement',
    sortable: false,
    label: vm.$t('reports.operations-history.visualization.complement'),
    class: 'table-cell__complement',
  },
  {
    key: 'companyName',
    sortable: false,
    label: vm.$t('reports.operations-history.visualization.company'),
  },
  {
    key: 'regionalName',
    sortable: false,
    label: vm.$t('reports.operations-history.visualization.regional'),
  },
  {
    key: 'installationName',
    sortable: false,
    label: vm.$t('reports.operations-history.visualization.installation'),
  },
  {
    key: 'assetName',
    sortable: false,
    label: vm.$t('reports.operations-history.visualization.asset'),
  },
  {
    key: 'moduleName',
    sortable: false,
    label: vm.$t('reports.operations-history.visualization.module'),
  },
  {
    key: 'action',
    sortable: false,
    label: '',
  },
]);

export default fields;
